import React, { useEffect, useState } from "react";
import { EditOutlined } from "@mui/icons-material";
import SelectLeadCaptureFormModal from "./add-lead-capture-form";

interface OurServicesProps {
  isForSharing: boolean;
  ourServiceData: any;
  setOurServiceData: any;
  sectionVisibility: any;
  setSectionVisibility: any;
  primaryColor?: string;
  accentColor?: string;
  canWrite?: boolean;
  canDelete?: boolean;
}

const OurServices: React.FC<OurServicesProps> = ({
  isForSharing,
  ourServiceData,
  setOurServiceData,
  sectionVisibility,
  setSectionVisibility,
  primaryColor,
  accentColor,
  canWrite = false,
  canDelete = false,
}) => {
  const [showLeadCaptureFormModal, setShowLeadCaptureFormModal] =
    useState(false);
  const [selectedLeadCaptureForm, setSelectedLeadCaptureForm] = useState<{
    id: number;
    formName: string;
    formLink: string;
  } | null>(null);
  useEffect(() => {
    if (ourServiceData?.leadCaptureFormData) {
      setSelectedLeadCaptureForm(ourServiceData?.leadCaptureFormData);
    } else {
      setSelectedLeadCaptureForm(null);
    }
  }, [ourServiceData]);
  const handleFormSelection = () => {
    setOurServiceData((prevData: any) => ({
      ...prevData,
      leadCaptureFormData: { ...selectedLeadCaptureForm },
    }));
  };
  const starIcon = `https://afp-crm-qa.s3.us-east-1.amazonaws.com/Camapaign-Landing-Pages-Assets/ServiceStarIcon.svg`;
  const formLink = ourServiceData?.leadCaptureFormData?.formLink;
  return (
    <div>
      <div id="our-service" style={{ padding: "20px 60px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            position: "relative",
            minHeight: "45px",
          }}
          className={
            sectionVisibility?.["partner-success-metrics"] && !isForSharing
              ? "section-header"
              : ""
          }
        >
          {sectionVisibility?.["our-service"] && !isForSharing && (
            <div style={{ display: "flex", alignItems: "center" }}>
              <h3
                style={{
                  fontSize: "30px",
                  fontWeight: 500,
                  border: "none",
                  background: "transparent",
                  margin: 0,
                  wordBreak: "break-word",
                }}
              >
                Our Services
              </h3>
            </div>
          )}
          {!isForSharing && (
            <button
              onClick={() => {
                if (setSectionVisibility) {
                  setSectionVisibility((prev: any) => ({
                    ...prev,
                    "our-service": !prev["our-service"],
                  }));
                }
              }}
              style={{
                position: "absolute",
                right: -40,
                cursor: canWrite ? "pointer" : "not-allowed",
                width: "147px",
                height: "42px",
                border: "none",
                borderRadius: "8px",
                backgroundColor: "#fff",
                color: canWrite ? "#000000" : "rgba(16, 16, 16, 0.3)",
                boxShadow: "0 0 8px rgba(0,0,0,0.3)",
                padding: "6px 24px",
                fontSize: "15px",
                fontFamily: "Roboto, sans-serif",
              }}
              className={`our-service-collapsible-section-button ${sectionVisibility?.["our-service"] ? "toggle-section-button" : ""}`}
              disabled={!canWrite}
            >
              {sectionVisibility?.["our-service"]
                ? "Show Section"
                : "Hide Section"}
            </button>
          )}
        </div>

        {!sectionVisibility?.["our-service"] && (
          <div style={{ height: "auto" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "10px",
              }}
            >
              <div>
                {!isForSharing && ourServiceData.isTitleEditing ? (
                  <input
                    type="text"
                    value={ourServiceData.title}
                    autoFocus
                    onBlur={() => {
                      setOurServiceData({
                        ...ourServiceData,
                        isTitleEditing: false,
                      });
                    }}
                    onChange={(e) =>
                      setOurServiceData({
                        ...ourServiceData,
                        title: e.target.value,
                      })
                    }
                    style={{
                      background: "transparent",
                      border: "none",
                      outline: "none",
                      fontSize: "30px",
                      fontWeight: "500",
                      textAlign: "center",
                      width: `${ourServiceData.title.length + 1}ch`,
                      margin: 0,
                      fontFamily: "Roboto, sans-serif",
                    }}
                    maxLength={40}
                  />
                ) : (
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 8 }}
                  >
                    <h3
                      style={{
                        textAlign: "center",
                        fontWeight: "500",
                        fontSize: "30px",
                        flex: 1,
                        margin: 0,
                        width: "auto",
                        maxWidth: "750px",
                        wordWrap: "break-word",
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        cursor: "default",
                      }}
                      title={ourServiceData.title}
                    >
                      {ourServiceData.title}
                    </h3>
                    {!isForSharing && (
                      <button
                        style={{
                          background: "#fff",
                          border: "1px solid #ccc",
                          cursor: canWrite ? "pointer" : "not-allowed",
                          display: "flex",
                          alignItems: "center",
                          borderRadius: "50%",
                          padding: "2px",
                          fontFamily: "Roboto, sans-serif",
                        }}
                        onClick={() => {
                          setOurServiceData({
                            ...ourServiceData,
                            isTitleEditing: !ourServiceData.isTitleEditing,
                          });
                        }}
                        disabled={!canWrite}
                      >
                        <EditOutlined fontSize="small" />
                      </button>
                    )}
                  </div>
                )}
              </div>
              <div>
                {!isForSharing && ourServiceData.isSubHeadingEditing ? (
                  <input
                    type="text"
                    value={ourServiceData.subHeading}
                    autoFocus
                    onBlur={() => {
                      setOurServiceData({
                        ...ourServiceData,
                        isSubHeadingEditing: false,
                      });
                    }}
                    onChange={(e) =>
                      setOurServiceData({
                        ...ourServiceData,
                        subHeading: e.target.value,
                      })
                    }
                    style={{
                      background: "transparent",
                      border: "none",
                      outline: "none",
                      fontSize: "18px",
                      textAlign: "center",
                      width: `${ourServiceData.subHeading.length + 1}ch`,
                      margin: 0,
                      fontFamily: "Roboto, sans-serif",
                    }}
                    maxLength={75}
                  />
                ) : (
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 8 }}
                  >
                    <p
                      style={{
                        textAlign: "center",
                        fontSize: "18px",
                        margin: 0,
                        width: "auto",
                        maxWidth: "750px",
                        wordWrap: "break-word",
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        cursor: "default",
                      }}
                      title={ourServiceData.subHeading}
                    >
                      {ourServiceData.subHeading}
                    </p>
                    {!isForSharing && (
                      <button
                        style={{
                          background: "#fff",
                          border: "1px solid #ccc",
                          cursor: canWrite ? "pointer" : "not-allowed",
                          display: "flex",
                          alignItems: "center",
                          borderRadius: "50%",
                          padding: "2px",
                          fontFamily: "Roboto, sans-serif",
                        }}
                        onClick={() => {
                          setOurServiceData({
                            ...ourServiceData,
                            isSubHeadingEditing:
                              !ourServiceData.isSubHeadingEditing,
                          });
                        }}
                        disabled={!canWrite}
                      >
                        <EditOutlined fontSize="small" />
                      </button>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                margin: "0 10px",
                gap: "20px",
                justifyContent: "center",
              }}
              className="service-card-section"
            >
              {ourServiceData?.services
                ?.filter((service: any) => !service.isRemoveService)
                .map((service: any) => (
                  <div
                    key={service.id}
                    className="service-card"
                    style={{
                      width: "calc(30% - 100px)",
                      boxShadow: "0 0 4px 0 rgba(0, 0, 0, 0.25)",
                      borderRadius: "5px",
                      padding: "20px 10px",
                      position: "relative",
                    }}
                  >
                    <div>
                      {service.isTitleEditing && !isForSharing ? (
                        <input
                          type="text"
                          value={service.title}
                          onChange={(e) => {
                            const updatedServices = ourServiceData.services.map(
                              (s: any) =>
                                s.id === service.id
                                  ? { ...s, title: e.target.value }
                                  : s
                            );
                            setOurServiceData({
                              ...ourServiceData,
                              services: updatedServices,
                            });
                          }}
                          style={{
                            background: "transparent",
                            border: "none",
                            outline: "none",
                            fontSize: "19px",
                            fontWeight: "bold",
                            width: `${service.title.length + 1}ch`,
                            margin: 0,
                            maxWidth: "calc(100% - 42px)",
                          }}
                          maxLength={40}
                          autoFocus
                          onBlur={() => {
                            const updatedServices = ourServiceData.services.map(
                              (s: any) =>
                                s.id === service.id
                                  ? { ...s, isTitleEditing: false }
                                  : s
                            );
                            setOurServiceData({
                              ...ourServiceData,
                              services: updatedServices,
                            });
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                            maxWidth: "calc(100% - 42px)",
                          }}
                        >
                          <h4
                            style={{
                              margin: 0,
                              width: "auto",
                              maxWidth: "280px",
                              fontSize: "19px",
                              wordWrap: "break-word",
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                              cursor: "default",
                            }}
                            title={service.title}
                          >
                            {service.title}
                          </h4>
                          {!isForSharing && (
                            <button
                              style={{
                                background: "#fff",
                                border: "1px solid #ccc",
                                cursor: canWrite ? "pointer" : "not-allowed",
                                display: "flex",
                                alignItems: "center",
                                borderRadius: "50%",
                                padding: "2px",
                                fontFamily: "Roboto, sans-serif",
                              }}
                              onClick={() => {
                                const updatedServices =
                                  ourServiceData.services.map((s: any) =>
                                    s.id === service.id
                                      ? {
                                          ...s,
                                          isTitleEditing: !s.isTitleEditing,
                                        }
                                      : s
                                  );
                                setOurServiceData({
                                  ...ourServiceData,
                                  services: updatedServices,
                                });
                              }}
                              disabled={!canWrite}
                            >
                              <EditOutlined fontSize="small" />
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                    <div>
                      {service.isDescriptionEditing && !isForSharing ? (
                        <input
                          type="text"
                          value={service.description}
                          onChange={(e) => {
                            const updatedServices = ourServiceData.services.map(
                              (s: any) =>
                                s.id === service.id
                                  ? { ...s, description: e.target.value }
                                  : s
                            );
                            setOurServiceData({
                              ...ourServiceData,
                              services: updatedServices,
                            });
                          }}
                          style={{
                            background: "transparent",
                            borderRadius: "4px",
                            outline: "none",
                            border: "none",
                            padding: "10px 10px 10px 0px",
                            fontSize: "15px",
                            width: `${service.description.length + 1}ch`,
                            maxWidth: "280px",
                            margin: "10px 10px 10px 0px",
                            fontFamily: "Roboto, sans-serif",
                          }}
                          maxLength={75}
                          autoFocus
                          onBlur={() => {
                            const updatedServices = ourServiceData.services.map(
                              (s: any) =>
                                s.id === service.id
                                  ? { ...s, isDescriptionEditing: false }
                                  : s
                            );
                            setOurServiceData({
                              ...ourServiceData,
                              services: updatedServices,
                            });
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                          }}
                        >
                          <p
                            style={{
                              width: "auto",
                              maxWidth: "280px",
                              fontSize: "15px",
                              wordWrap: "break-word",
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                              cursor: "default",
                            }}
                            title={service.description}
                          >
                            {service.description}
                          </p>
                          {!isForSharing && (
                            <button
                              style={{
                                background: "#fff",
                                border: "1px solid #ccc",
                                cursor: canWrite ? "pointer" : "not-allowed",
                                display: "flex",
                                alignItems: "center",
                                borderRadius: "50%",
                                padding: "2px",
                                fontFamily: "Roboto, sans-serif",
                              }}
                              onClick={() => {
                                const updatedServices =
                                  ourServiceData.services.map((s: any) =>
                                    s.id === service.id
                                      ? {
                                          ...s,
                                          isDescriptionEditing:
                                            !s.isDescriptionEditing,
                                        }
                                      : s
                                  );
                                setOurServiceData({
                                  ...ourServiceData,
                                  services: updatedServices,
                                });
                              }}
                              disabled={!canWrite}
                            >
                              <EditOutlined fontSize="small" />
                            </button>
                          )}
                        </div>
                      )}
                    </div>

                    {!isForSharing && (
                      <button
                        onClick={() => {
                          const updatedServices = ourServiceData.services.map(
                            (s: any) =>
                              s.id === service.id
                                ? { ...s, isRemoveService: true }
                                : s
                          );
                          setOurServiceData({
                            ...ourServiceData,
                            services: updatedServices,
                          });
                        }}
                        style={{
                          marginLeft: "auto",
                          cursor: canWrite ? "pointer" : "not-allowed",
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          backgroundColor: "#fff",
                          color: canWrite ? "#000000" : "rgba(16, 16, 16, 0.3)",
                          padding: "10px",
                          fontSize: "12px",
                          fontFamily: "Roboto, sans-serif",
                        }}
                        disabled={!canWrite}
                      >
                        Remove Service
                      </button>
                    )}
                    <div
                      style={{
                        position: "absolute",
                        right: "0px",
                        top: "0px",
                        display: "flex",
                        width: "40px",
                        height: "40px",
                        backgroundColor: "rgba(249, 250, 251, 1)",
                        justifyContent: "center",
                        alignItems: "center",
                        borderBottomLeftRadius: "10px",
                        borderBottomRightRadius: "10px",
                      }}
                    >
                      <img
                        src={starIcon}
                        alt="Star Icon"
                        style={{
                          width: "25px",
                          height: "25px",
                        }}
                      />
                    </div>
                  </div>
                ))}
              {!isForSharing && (
                <div
                  style={{
                    width: "calc(50% - 100px)",
                    border: `1px dashed ${accentColor || "#000"}`,
                    borderRadius: "5px",
                    padding: "20px 10px",
                    textAlign: "center",
                    cursor: canWrite ? "pointer" : "not-allowed",
                  }}
                  onClick={() => {
                    if (!canWrite) return;
                    const newService = {
                      id: ourServiceData.services.length + 1,
                      title: `Service`,
                      isTitleEditing: false,
                      description: `Service description`,
                      isDescriptionEditing: false,
                      isRemoveService: false,
                    };

                    setOurServiceData((prevData: any) => ({
                      ...prevData,
                      services: [...prevData.services, newService],
                    }));
                  }}
                  className="service-card-button"
                >
                  <h4
                    style={{
                      color: canWrite ? accentColor : "rgba(16, 16, 16, 0.3)",
                    }}
                  >
                    Add Service +{" "}
                  </h4>
                </div>
              )}
            </div>

            <div style={{ textAlign: "center", marginTop: "10px" }}>
              {isForSharing ? (
                <a
                  href={formLink || "#our-service"}
                  target={formLink ? "_blank" : "_self"}
                  rel="noopener noreferrer"
                  style={{
                    textDecoration: "none",
                  }}
                >
                  <button
                    style={{
                      padding: "10px 20px",
                      border: "none",
                      color: "white",
                      backgroundColor: accentColor,
                      borderRadius: "5px",
                      fontSize: "15px",
                      cursor: "pointer",
                      fontFamily: "Roboto, sans-serif",
                    }}
                  >
                    Access All Features
                  </button>
                </a>
              ) : (
                <button
                  style={{
                    padding: "10px 20px",
                    border: "none",
                    color: "white",
                    fontSize: "15px",
                    backgroundColor: canWrite
                      ? accentColor
                      : "rgba(16, 16, 16, 0.3)",
                    borderRadius: "5px",
                    cursor: canWrite ? "pointer" : "not-allowed",
                    fontFamily: "Roboto, sans-serif",
                  }}
                  onClick={() => setShowLeadCaptureFormModal(true)}
                  disabled={!canWrite}
                >
                  Access All Features
                </button>
              )}
            </div>
          </div>
        )}
      </div>
      <SelectLeadCaptureFormModal
        isOpen={showLeadCaptureFormModal}
        setIsOpen={setShowLeadCaptureFormModal}
        selectedLeadCaptureForm={selectedLeadCaptureForm}
        setSelectedLeadCaptureForm={setSelectedLeadCaptureForm}
        onSave={handleFormSelection}
        ourServiceData={ourServiceData}
      />
    </div>
  );
};

export default OurServices;
